import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Switch from "react-switch";
import { Card, Text, Badge, Button, Icon, Collapsible, BlockStack, Banner, Tooltip, Modal, InlineStack, Link, Spinner } from '@shopify/polaris';
import {
    CodeIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    ArrowRightIcon,
    ChevronLeftIcon,
    SettingsIcon,
    MagicIcon,
} from "@shopify/polaris-icons";
import LogoForms from '../../../SnippetsJSONLD/index/components/LogoForms';
import Language from '../../../../../i18n/Language';
import {
    reqGetJLPageData,
    reqUpSwitchJsonLdSwitchV2,
    reqUpdJLSwitch,
    reqSaveJLData,
    reqBulkOpenJsonLd,
    reqGetStructuredDataGenerate,
    reqSaveStructuredDataContent,

} from '../../../../../api';
import { store } from '../../../../../redux/store';
import { setPageData } from '../../../../../redux/actions/getAppPageData';
import { cloneDeep } from 'lodash-es';
import SchemaContentEditor from './schemaContentEditor/SchemaContentEditor';
import { SCHEMA_KEY_EDITOR_TYPE, SCHEMA_KEY_CONTENT_FIELD, toSchemaApiBody, fromSchemaApiContent, parseSchemaContentString } from './schemaContentEditor/schemaEditorModel';
import SchemaSettingsModal from '../../../../../components/SchemaSettingsModal';
import { getPageOptions, getDefaultSelectedPages, buildSettingsCfg } from '../../../../../components/SchemaSettingsModal/schemaSettingsStats';
const t = Language;

let timerArr = [];
const StructuredData = (props) => {

    const {
        id,
        level,
        disabled,
        structureModalType,
        structured_data,
        isPublishState,
        jsonLdTestUrl,
        updOpenJSONLD,
        publishLoading,
        creditsPoints,
        ai_usage_status,
        aiUse,
        pagetype,
        STRUCTURED_DATA_TYPE_FIELDS,
        syncStructLoading,

    } = props;

    const childRef = useRef();
    const generateArrRef = useRef([]);

    // 结构数据数组
    const schemaArray = {
        "has_product": {
            title: "Product",
            desc: "Display product price, stock, and reviews in search results to improve visibility.",
            helpText: "Add product details like price, availability, and ratings to qualify for rich product results in search.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M20.9998 16C21.552 16 21.9998 15.5523 21.9998 15C21.9998 14.4477 21.552 14 20.9998 14C20.4475 14 19.9998 14.4477 19.9998 15C19.9998 15.5523 20.4475 16 20.9998 16Z" fill="#8A8A8A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M19.2757 11.5C18.2566 11.5 17.2814 11.9148 16.5745 12.6488L12.3209 17.0661C11.2814 18.1455 11.2976 19.8585 12.3572 20.9181L15.2551 23.816C16.2184 24.7793 17.7757 24.794 18.757 23.8491L23.5041 19.2778C24.1403 18.6651 24.4998 17.8199 24.4998 16.9367V14.75C24.4998 12.9551 23.0447 11.5 21.2498 11.5H19.2757ZM17.655 13.6893C18.0791 13.2489 18.6642 13 19.2757 13H21.2498C22.2163 13 22.9998 13.7835 22.9998 14.75V16.9367C22.9998 17.4123 22.8062 17.8674 22.4636 18.1973L17.7165 22.7686C17.324 23.1466 16.7011 23.1407 16.3158 22.7554L13.4179 19.8575C12.9362 19.3758 12.9289 18.5972 13.4014 18.1065L17.655 13.6893Z" fill="#8A8A8A" />
            </svg>,
            switch: false,
            enabled: true,
        },
        "has_review": {
            title: "Review",
            desc: "Show review counts, star ratings, and review snippets on product pages.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M22.5 11C24.433 11 26 12.567 26 14.5V20.5C26 22.433 24.433 24 22.5 24H18.6211L17.0605 25.5605C16.6315 25.9895 15.9863 26.1179 15.4258 25.8857C14.8654 25.6535 14.5 25.1066 14.5 24.5V24H13.5C11.567 24 10 22.433 10 20.5V14.5C10 12.567 11.567 11 13.5 11H22.5ZM13.5 12.5C12.3954 12.5 11.5 13.3954 11.5 14.5V20.5C11.5 21.6046 12.3954 22.5 13.5 22.5H16V24.5L18 22.5H22.5C23.6046 22.5 24.5 21.6046 24.5 20.5V14.5C24.5 13.3954 23.6046 12.5 22.5 12.5H13.5ZM18.4229 13.5C18.6607 13.5 18.8781 13.6354 18.9834 13.8486L19.8662 15.6377L21.8418 15.9248C22.077 15.9591 22.2722 16.1245 22.3457 16.3506C22.4191 16.5768 22.3578 16.8252 22.1875 16.9912L20.7578 18.3838L21.0957 20.3506C21.1359 20.585 21.04 20.8221 20.8477 20.9619C20.6553 21.1016 20.3999 21.1204 20.1895 21.0098L18.4229 20.0801L16.6562 21.0098C16.4457 21.1203 16.1904 21.1017 15.998 20.9619C15.8059 20.822 15.7098 20.5849 15.75 20.3506L16.0869 18.3838L14.6582 16.9912C14.488 16.8252 14.4266 16.5767 14.5 16.3506C14.5735 16.1245 14.7687 15.9592 15.0039 15.9248L16.9785 15.6377L17.8623 13.8486C17.9676 13.6354 18.185 13.5001 18.4229 13.5ZM17.9551 16.4854C17.8641 16.6697 17.6878 16.7985 17.4844 16.8281L16.4375 16.9795L17.1943 17.7178C17.3416 17.8614 17.4088 18.0687 17.374 18.2715L17.1943 19.3145L18.1318 18.8223L18.2021 18.79C18.3681 18.7274 18.5547 18.7387 18.7139 18.8223L19.6504 19.3145L19.4717 18.2715C19.4369 18.0688 19.5042 17.8613 19.6514 17.7178L20.4072 16.9795L19.3613 16.8281C19.1579 16.7984 18.9816 16.6697 18.8906 16.4854L18.4229 15.5371L17.9551 16.4854Z" fill="#8A8A8A" />
            </svg>,
            enabled: false,
        },
        "has_shipping": {
            title: "Shipping Information",
            desc: "Show shipping costs and delivery estimates in Google Search and merchant listings.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M22.3105 10.8906C23.8569 10.8907 25.1104 12.1441 25.1104 13.6904V18.6318C25.1104 19.0736 24.7523 19.4316 24.3105 19.4316C23.8687 19.4316 23.5107 19.0737 23.5107 18.6318V13.6904C23.5107 13.0277 22.9732 12.4903 22.3105 12.4902H21.3242V15.9893C21.3241 17.4443 19.565 18.1725 18.5361 17.1436L18.0234 16.6318C18.0105 16.6188 17.9896 16.6189 17.9766 16.6318L17.4639 17.1436C16.435 18.1725 14.6759 17.4443 14.6758 15.9893V12.4902H13.6895C13.0267 12.4902 12.4893 13.0277 12.4893 13.6904V22.3115C12.4893 22.9742 13.0268 23.5117 13.6895 23.5117H18.6309C19.0727 23.5117 19.4307 23.8697 19.4307 24.3115C19.4306 24.7533 19.0726 25.1113 18.6309 25.1113H13.6895C12.1431 25.1113 10.8897 23.8579 10.8896 22.3115V13.6904C10.8896 12.144 12.1431 10.8906 13.6895 10.8906H22.3105ZM21.7871 19.0938C23.2743 19.094 24.4795 20.2999 24.4795 21.7871C24.4794 22.2376 24.3665 22.6611 24.1709 23.0342L24.5605 23.4238C24.873 23.7362 24.873 24.2423 24.5605 24.5547C24.2481 24.8671 23.7421 24.8671 23.4297 24.5547L23.042 24.167C22.667 24.3651 22.2407 24.4794 21.7871 24.4795C20.2999 24.4795 19.094 23.2743 19.0938 21.7871C19.0938 20.2997 20.2997 19.0938 21.7871 19.0938ZM21.7871 20.6934C21.1834 20.6934 20.6934 21.1834 20.6934 21.7871C20.6936 22.3906 21.1835 22.8799 21.7871 22.8799C22.3905 22.8797 22.8797 22.3905 22.8799 21.7871C22.8799 21.1835 22.3906 20.6936 21.7871 20.6934ZM16.2754 15.9893C16.2754 15.9998 16.277 16.0048 16.2773 16.0059L16.2783 16.0078C16.2799 16.0098 16.2853 16.0151 16.2959 16.0195C16.3069 16.0241 16.315 16.0237 16.3174 16.0234H16.3193C16.3201 16.023 16.3244 16.0203 16.332 16.0127L16.8447 15.5C17.4825 14.8624 18.5164 14.8625 19.1543 15.5L19.667 16.0127C19.6751 16.0208 19.6801 16.0232 19.6807 16.0234H19.6816C19.6833 16.0237 19.6914 16.0244 19.7031 16.0195C19.7144 16.0149 19.7203 16.0096 19.7217 16.0078L19.7227 16.0059C19.723 16.0045 19.7236 15.9994 19.7236 15.9893V12.4902H16.2754V15.9893Z" fill="#8A8A8A" />
            </svg>,
            enabled: false,
        },
        "has_return": {
            title: "Merchant Return Policy",
            desc: "Show return windows and return fees in Google Search and merchant listings.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path fillRule="evenodd" clipRule="evenodd" d="M23 19.25V16H13V22.75C13 22.8881 13.1119 23 13.25 23H17.25C17.6642 23 18 23.3358 18 23.75C18 24.1642 17.6642 24.5 17.25 24.5H13.25C12.2835 24.5 11.5 23.7165 11.5 22.75V15.8866C11.5 15.3171 11.6768 14.7617 12.0059 14.297L13.3146 12.4495C13.7365 11.8539 14.4209 11.5 15.1507 11.5H20.9472C21.6995 11.5 22.402 11.876 22.8193 12.5019L24.0381 14.3301C24.3393 14.7819 24.5 15.3126 24.5 15.8556V19.25C24.5 19.6642 24.1642 20 23.75 20C23.3358 20 23 19.6642 23 19.25ZM14.5387 13.3165C14.6793 13.118 14.9074 13 15.1507 13H17.25V14.5H13.7003L14.5387 13.3165ZM22.3486 14.5H18.75V13H20.9472C21.198 13 21.4322 13.1253 21.5713 13.334L22.3486 14.5Z" fill="#8A8A8A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M14 18C14 17.4477 14.4477 17 15 17H19C19.5523 17 20 17.4477 20 18V21C20 21.5523 19.5523 22 19 22H15C14.4477 22 14 21.5523 14 21V18ZM15.5 18.5V20.5H18.5V18.5H15.5Z" fill="#8A8A8A" />
                <path d="M25.5 21C25.5 20.5858 25.1642 20.25 24.75 20.25C24.3358 20.25 24 20.5858 24 21V21.5C24 22.4665 23.2165 23.25 22.25 23.25H21.3107L21.5303 23.0303C21.8232 22.7374 21.8232 22.2626 21.5303 21.9697C21.2374 21.6768 20.7626 21.6768 20.4697 21.9697L18.9697 23.4697C18.6768 23.7626 18.6768 24.2374 18.9697 24.5303L20.4697 26.0303C20.7626 26.3232 21.2374 26.3232 21.5303 26.0303C21.8232 25.7374 21.8232 25.2626 21.5303 24.9697L21.3107 24.75H22.25C24.0449 24.75 25.5 23.2949 25.5 21.5V21Z" fill="#8A8A8A" />
            </svg>,
            enabled: false,
        },
        "has_article": {
            title: "Article",
            desc: "Qualify for rich article results with headline, author, and publish date.",
            helpText: "Add article metadata to help Google and AI better understand and cite your content.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M14.55 15.2498C14.55 14.8632 14.8634 14.5498 15.25 14.5498H20.75C21.1366 14.5498 21.45 14.8632 21.45 15.2498C21.45 15.6364 21.1366 15.9498 20.75 15.9498H15.25C14.8634 15.9498 14.55 15.6364 14.55 15.2498Z" fill="#8A8A8A" />
                <path d="M15 17.0498C14.6134 17.0498 14.3 17.3632 14.3 17.7498C14.3 18.1364 14.6134 18.4498 15 18.4498H17.25C17.6366 18.4498 17.95 18.1364 17.95 17.7498C17.95 17.3632 17.6366 17.0498 17.25 17.0498H15Z" fill="#8A8A8A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M11.5 14.25C11.5 12.7312 12.7312 11.5 14.25 11.5H21.75C23.2688 11.5 24.5 12.7312 24.5 14.25V19.75C24.5 19.9489 24.421 20.1397 24.2803 20.2803L20.2803 24.2803C20.1397 24.421 19.9489 24.5 19.75 24.5H14.25C12.7312 24.5 11.5 23.2688 11.5 21.75V14.25ZM14.25 13C13.5596 13 13 13.5596 13 14.25V21.75C13 22.4404 13.5596 23 14.25 23H19V20.75C19 19.7835 19.7835 19 20.75 19H23V14.25C23 13.5596 22.4404 13 21.75 13H14.25ZM21.9393 20.5H20.75C20.6119 20.5 20.5 20.6119 20.5 20.75V21.9393L21.9393 20.5Z" fill="#8A8A8A" />
            </svg>,
            switch: false,
            enabled: true,
        },
        "has_author": {
            title: "Author",
            desc: "Help search engines understand article ownership and credibility.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path fillRule="evenodd" clipRule="evenodd" d="M18.0001 11C16.0671 11 14.5001 12.567 14.5001 14.5C14.5001 16.433 16.0671 18 18.0001 18C19.9331 18 21.5001 16.433 21.5001 14.5C21.5001 12.567 19.9331 11 18.0001 11ZM16.0001 14.5C16.0001 13.3954 16.8955 12.5 18.0001 12.5C19.1046 12.5 20.0001 13.3954 20.0001 14.5C20.0001 15.6046 19.1046 16.5 18.0001 16.5C16.8955 16.5 16.0001 15.6046 16.0001 14.5Z" fill="#8A8A8A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M23.484 22.2268C22.3776 20.2352 20.2784 19 18.0001 19C15.7218 19 13.6225 20.2352 12.5161 22.2268L12.0794 23.0128C11.5841 23.9043 12.2288 25 13.2487 25H22.7514C23.7713 25 24.416 23.9043 23.9207 23.0128L23.484 22.2268ZM13.8273 22.9552C14.6692 21.4398 16.2665 20.5 18.0001 20.5C19.7336 20.5 21.3309 21.4398 22.1728 22.9552L22.4754 23.5H13.5247L13.8273 22.9552Z" fill="#8A8A8A" />
            </svg>,
            enabled: false,
        },
        "has_faq": {
            title: "FAQ Schema",
            desc: "Mark up FAQs so answers can appear directly in search results and AI-generated answers.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M11.6071 17.0893C11.6071 15.1662 13.1662 13.6071 15.0893 13.6071H19.375C19.8188 13.6071 20.1786 13.2474 20.1786 12.8036C20.1786 12.3598 19.8188 12 19.375 12H15.0893C12.2786 12 10 14.2786 10 17.0893V17.8929C10 20.1425 11.459 22.05 13.4821 22.7229V24.8571C13.4821 25.1606 13.6531 25.4382 13.9241 25.5748C14.1951 25.7113 14.52 25.6835 14.7639 25.503L18.1686 22.9821H19.9107C22.7214 22.9821 25 20.7036 25 17.8929C25 17.4491 24.6402 17.0893 24.1964 17.0893C23.7526 17.0893 23.3929 17.4491 23.3929 17.8929C23.3929 19.816 21.8338 21.375 19.9107 21.375H17.9035C17.7314 21.375 17.5637 21.4303 17.4254 21.5327L15.0893 23.2623V22.1034C15.0893 21.7173 14.8148 21.3858 14.4355 21.3139C12.8249 21.0083 11.6071 19.5919 11.6071 17.8929V17.0893Z" fill="#5B7CFF" />
                <path d="M14.0179 15.4821C13.5741 15.4821 13.2143 15.8419 13.2143 16.2857C13.2143 16.7295 13.5741 17.0893 14.0179 17.0893H19.9107C20.3545 17.0893 20.7143 16.7295 20.7143 16.2857C20.7143 15.8419 20.3545 15.4821 19.9107 15.4821H14.0179Z" fill="#5B7CFF" />
                <path d="M13.2143 18.6964C13.2143 18.2526 13.5741 17.8929 14.0179 17.8929H17.7679C18.2117 17.8929 18.5714 18.2526 18.5714 18.6964C18.5714 19.1402 18.2117 19.5 17.7679 19.5H14.0179C13.5741 19.5 13.2143 19.1402 13.2143 18.6964Z" fill="#5B7CFF" />
                <path d="M23.5734 10.3051C23.7123 9.89831 24.2877 9.89831 24.4266 10.3051L24.9325 11.7866C24.9776 11.9187 25.0813 12.0224 25.2134 12.0675L26.6949 12.5734C27.1017 12.7123 27.1017 13.2877 26.6949 13.4266L25.2134 13.9325C25.0813 13.9776 24.9776 14.0813 24.9325 14.2134L24.4266 15.6949C24.2877 16.1017 23.7123 16.1017 23.5734 15.6949L23.0675 14.2134C23.0224 14.0813 22.9187 13.9776 22.7866 13.9325L21.3051 13.4266C20.8983 13.2877 20.8983 12.7123 21.3051 12.5734L22.7866 12.0675C22.9187 12.0224 23.0224 11.9187 23.0675 11.7866L23.5734 10.3051Z" fill="#5B7CFF" />
                <path d="M20.8578 9.10169C20.9041 8.9661 21.0959 8.9661 21.1422 9.10169L21.3108 9.59554C21.3259 9.63956 21.3604 9.67414 21.4045 9.68917L21.8983 9.85781C22.0339 9.90412 22.0339 10.0959 21.8983 10.1422L21.4045 10.3108C21.3604 10.3259 21.3259 10.3604 21.3108 10.4045L21.1422 10.8983C21.0959 11.0339 20.9041 11.0339 20.8578 10.8983L20.6892 10.4045C20.6741 10.3604 20.6396 10.3259 20.5955 10.3108L20.1017 10.1422C19.9661 10.0959 19.9661 9.90412 20.1017 9.85781L20.5955 9.68917C20.6396 9.67414 20.6741 9.63956 20.6892 9.59554L20.8578 9.10169Z" fill="#5B7CFF" />
            </svg>,
        },
        "has_how_to": {
            title: "How-To Schema",
            desc: "Extract step-by-step instructions to increase the chance of being cited in AI search answers.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <rect x="11" y="12.332" width="5.83333" height="2.33333" rx="1.16667" fill="#5B7CFF" />
                <rect x="11" y="17" width="8.16667" height="2.33333" rx="1.16667" fill="#5B7CFF" />
                <rect x="11" y="21.668" width="14" height="2.33333" rx="1.16667" fill="#5B7CFF" />
                <path d="M21.0023 10.3559C21.1644 9.88136 21.8356 9.88136 21.9977 10.3559L22.5879 12.0844C22.6405 12.2385 22.7615 12.3595 22.9156 12.4121L24.6441 13.0023C25.1186 13.1644 25.1186 13.8356 24.6441 13.9977L22.9156 14.5879C22.7615 14.6405 22.6405 14.7615 22.5879 14.9156L21.9977 16.6441C21.8356 17.1186 21.1644 17.1186 21.0023 16.6441L20.4121 14.9156C20.3595 14.7615 20.2385 14.6405 20.0844 14.5879L18.3559 13.9977C17.8814 13.8356 17.8814 13.1644 18.3559 13.0023L20.0844 12.4121C20.2385 12.3595 20.3595 12.2385 20.4121 12.0844L21.0023 10.3559Z" fill="url(#paint0_linear_21691_109308)" />
                <path d="M23.6674 17.1186C23.7214 16.9605 23.9452 16.9605 23.9992 17.1186L24.1959 17.6948C24.2135 17.7462 24.2538 17.7865 24.3052 17.804L24.8813 18.0008C25.0395 18.0548 25.0395 18.2785 24.8813 18.3326L24.3052 18.5293C24.2538 18.5468 24.2135 18.5872 24.1959 18.6385L23.9992 19.2147C23.9452 19.3729 23.7214 19.3729 23.6674 19.2147L23.4707 18.6385C23.4531 18.5872 23.4128 18.5468 23.3614 18.5293L22.7853 18.3326C22.6271 18.2785 22.6271 18.0548 22.7853 18.0008L23.3614 17.804C23.4128 17.7865 23.4531 17.7462 23.4707 17.6948L23.6674 17.1186Z" fill="#5B7CFF" />
                <defs>
                    <linearGradient id="paint0_linear_21691_109308" x1="21.5" y1="10" x2="21.5" y2="17" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#5B7CFF" />
                        <stop offset="1" stopColor="#5B7CFF" />
                    </linearGradient>
                </defs>
            </svg>,
        },
        "has_breadcrumb": {
            title: "Breadcrumb",
            desc: "Help search engines understand your site structure",
            helpText: "Clarify site hierarchy and improve how Google and AI crawlers understand your page structure.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M20.2212 12.9562C20.3349 12.558 20.1043 12.1428 19.7061 12.0291C19.3078 11.9153 18.8927 12.1459 18.7789 12.5442L15.7789 23.0442C15.6651 23.4424 15.8957 23.8575 16.294 23.9713C16.6922 24.0851 17.1074 23.8545 17.2212 23.4562L20.2212 12.9562Z" fill="#8A8A8A" />
                <path d="M15.0303 14.2199C15.3232 14.5128 15.3232 14.9877 15.0303 15.2806L12.3107 18.0002L15.0303 20.7199C15.3232 21.0128 15.3232 21.4877 15.0303 21.7806C14.7374 22.0735 14.2626 22.0735 13.9697 21.7806L10.7197 18.5306C10.4268 18.2377 10.4268 17.7628 10.7197 17.4699L13.9697 14.2199C14.2626 13.927 14.7374 13.927 15.0303 14.2199Z" fill="#8A8A8A" />
                <path d="M20.9697 21.7806C20.6768 21.4877 20.6768 21.0128 20.9697 20.7199L23.6893 18.0002L20.9697 15.2806C20.6768 14.9877 20.6768 14.5128 20.9697 14.2199C21.2626 13.927 21.7374 13.927 22.0303 14.2199L25.2803 17.4699C25.5732 17.7628 25.5732 18.2377 25.2803 18.5306L22.0303 21.7806C21.7374 22.0735 21.2626 22.0735 20.9697 21.7806Z" fill="#8A8A8A" />
            </svg>,
            switch: false,
            enabled: true,
        },
        "has_organization": {
            title: "Organization",
            desc: "Strengthen brand signals across search engines.",
            helpText: "Boost brand authority in Google and AI search results and improve citation rates.",
            status: 0,
            icon: <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" fill="white" />
                <path d="M8 0.25H28C32.2802 0.25 35.75 3.71979 35.75 8V28C35.75 32.2802 32.2802 35.75 28 35.75H8C3.71979 35.75 0.25 32.2802 0.25 28V8C0.25 3.71979 3.71979 0.25 8 0.25Z" stroke="#E3E3E3" strokeWidth="0.5" />
                <path d="M14.75 17C14.3358 17 14 17.3358 14 17.75C14 18.1642 14.3358 18.5 14.75 18.5H15.25C15.6642 18.5 16 18.1642 16 17.75C16 17.3358 15.6642 17 15.25 17H14.75Z" fill="#8A8A8A" />
                <path d="M16.75 17.75C16.75 17.3358 17.0858 17 17.5 17H18C18.4142 17 18.75 17.3358 18.75 17.75C18.75 18.1642 18.4142 18.5 18 18.5H17.5C17.0858 18.5 16.75 18.1642 16.75 17.75Z" fill="#8A8A8A" />
                <path d="M17.5 14.5C17.0858 14.5 16.75 14.8358 16.75 15.25C16.75 15.6642 17.0858 16 17.5 16H18C18.4142 16 18.75 15.6642 18.75 15.25C18.75 14.8358 18.4142 14.5 18 14.5H17.5Z" fill="#8A8A8A" />
                <path d="M14 15.25C14 14.8358 14.3358 14.5 14.75 14.5H15.25C15.6642 14.5 16 14.8358 16 15.25C16 15.6642 15.6642 16 15.25 16H14.75C14.3358 16 14 15.6642 14 15.25Z" fill="#8A8A8A" />
                <path fillRule="evenodd" clipRule="evenodd" d="M11.5 13.25C11.5 12.2835 12.2835 11.5 13.25 11.5H19.5C20.4665 11.5 21.25 12.2835 21.25 13.25V13.75H22.75C23.7165 13.75 24.5 14.5335 24.5 15.5V22.75C24.5 23.7165 23.7165 24.5 22.75 24.5H13.25C12.2835 24.5 11.5 23.7165 11.5 22.75V13.25ZM15.75 23H17V21.75C17 21.6119 16.8881 21.5 16.75 21.5H16C15.8619 21.5 15.75 21.6119 15.75 21.75V23ZM18.5 23V21.75C18.5 20.7835 17.7165 20 16.75 20H16C15.0335 20 14.25 20.7835 14.25 21.75V23H13.25C13.1119 23 13 22.8881 13 22.75V13.25C13 13.1119 13.1119 13 13.25 13H19.5C19.6381 13 19.75 13.1119 19.75 13.25V22.75C19.75 22.8881 19.6381 23 19.5 23H18.5ZM21.25 22.75V15.25H22.75C22.8881 15.25 23 15.3619 23 15.5V22.75C23 22.8881 22.8881 23 22.75 23H21.2323C21.244 22.9183 21.25 22.8349 21.25 22.75Z" fill="#8A8A8A" />
            </svg>,
            switch: false,
            enabled: true,
        },
    };

    // origin
    const [loading, setLoading] = useState(true);
    const [logo_url, setLogoUrl] = useState('');
    const [organization_name, setOrganizationName] = useState('');
    const [social_media_data, setSocialMediaData] = useState({});
    const [originData, setOriginData] = useState({});

    // 结构化数据编辑状态
    const [structuredDataCollStatus, setStructuredDataCollStatus] = useState(true);
    const [structuredDataModalState, setStructuredDataModalState] = useState(false);
    const [isShowOriginalData, setIsShowOriginalData] = useState(false);
    const [schemaAll, setSchemaAll] = useState({});
    const [isShowFaqBanner, setIsShowFaqBanner] = useState(false);
    const [isShowHowToBanner, setIsShowHowToBanner] = useState(false);
    const [activeNum, setActiveNum] = useState(0);
    const [switchType, setSwitchType] = useState('');
    const [orgFirst, setOrgFirst] = useState(true);
    const [generateType, setGenerateType] = useState([]);
    // 本会话内"点击 Generate 且生成成功"的 schemaKey 集合，仅这些才按 AI 生成态着色
    const [aiGeneratedKeys, setAiGeneratedKeys] = useState([]);
    const [errorBanner, setErrorBanner] = useState('');
    const [embedModalStatus, setEmbedModalStatus] = useState(false);
    const [embedUrl, setEmbedUrl] = useState('');
    const [actionDisabled, setActionDisabled] = useState(false);
    const [pageUnpublishModalStatus, setPageUnpublishModalStatus] = useState(false);
    const [publishPageLoading, setPublishPageLoading] = useState(false);
    const [optionSel, setOptionSel] = useState([]);
    const [isPublishPage, setIsPublishPage] = useState(false);
    const [jsonldTestUrl, setJsonldTestUrl] = useState('');
    const [imageUploadStatus, setImageUploadStatus] = useState(false);
    const [schemaEditor, setSchemaEditor] = useState({ open: false, schemaKey: '', session: 0 });
    const [schemaContentStore, setSchemaContentStore] = useState({});
    const [schemaSaving, setSchemaSaving] = useState(false);
    const [schemaSwitchArray, setSchemaSwitchArray] = useState({
        "has_product": {
            switch: false,
        },
        "has_breadcrumb": {
            switch: false,
        },
        "has_organization": {
            switch: false,
        },
        "has_article": {
            switch: false,
        },
    }); // 结构化数据开关状态
    const [sourceType, setSourceType] = useState('');
    const [objId, setObjId] = useState(-1);

    // FAQ / How-To 模块设置弹窗（复用 SnippetsJSONLD 的 SchemaSettingsModal）
    const [statistics, setStatistics] = useState(null); // reqGetJLPageData 的 statistics
    const [configData, setConfigData] = useState(null); // reqGetJLPageData 的 config
    const [faqHowtoPageTypes, setFaqHowtoPageTypes] = useState({ 'FAQ Schema': [], 'How-To Schema': [] });
    const [settingsModalType, setSettingsModalType] = useState(''); // '' | 'FAQ Schema' | 'How-To Schema'
    const [settingsSelectedPages, setSettingsSelectedPages] = useState([]);
    const [settingsSaveLoading, setSettingsSaveLoading] = useState(false);
    const [techVideoState, setTechVideoState] = useState(false); // "View how" 教学视频弹窗

    // schema item key -> SchemaSettingsModal 的 moduleType
    const ITEM_TO_MODULE_TYPE = {
        has_faq: 'FAQ Schema',
        has_how_to: 'How-To Schema',
    };
    // moduleType -> 保存接口 action 字段
    const FAQ_HOWTO_ACTION_MAP = {
        'FAQ Schema': 'faqSettings',
        'How-To Schema': 'howtoSettings',
    };

    useEffect(() => {
        setSourceType(pagetype);
    }, [pagetype]);

    useEffect(() => {
        setObjId(id);
    }, [id]);

    /**
     * 获取开关状态
     */
    const getSwitchStatus = async (data) => {
        let res = data || (await reqGetJLPageData());
        if (res.ack === 1) {
            if (Boolean(data)) {
                getSwitchStatus();
            } else {
                setLoading(false);
            }
            // 判断是否第一次 第一次则缓存
            store.dispatch(setPageData(['StructuredData', res]));
            let resData = res.data;
            // FAQ / How-To 模块设置弹窗所需的统计与配置
            setStatistics(resData.statistics || null);
            setConfigData(resData.config || null);
            setFaqHowtoPageTypes({
                'FAQ Schema': resData.config?.faq?.page_types || [],
                'How-To Schema': resData.config?.howto?.page_types || [],
            });
            // setLogoStatus(Boolean(resData.organization_switch));
            setLogoUrl(resData.logo_url);
            setOrganizationName(resData.organization_name);
            setSocialMediaData(resData.social_media_data);
            setOriginData({
                organization_name: resData.organization_name,
                social_media_data: resData.social_media_data,
                logo_url: resData.logo_url,
            });
            let artSel = [Boolean(resData.collection_switch) ? 'collection' : '', Boolean(resData.blog_switch) ? 'blog' : '', Boolean(resData.article_switch) ? 'blogpost' : ''];
            let artSelArr = artSel.filter(item => item !== '');
            setOptionSel(artSelArr);

            // 设置结构化数据开关状态
            let newArray = { ...schemaSwitchArray };
            newArray.has_product.switch = Boolean(resData.product_switch);
            newArray.has_breadcrumb.switch = Boolean(resData.breadcrumb_list_switch);
            newArray.has_organization.switch = Boolean(resData.organization_switch);
            newArray.has_article.switch = Boolean(resData.article_switch);
            setSchemaSwitchArray(newArray);
        } else {
            props.toggleToast(t(res.msg), true)
        }

        setSwitchType('');
    }

    useEffect(() => {
        const str = structured_data ? Object.keys(structured_data) : [];
        let all = schemaArray;
        str.forEach(item => {
            if (all[item]) {
                all[item].status = structured_data[item];
            }

            if (item === 'has_article') {
                all['has_author'].status = structured_data?.has_article;
            }
        })
        setSchemaAll(all);
        // 判断是否显示FAQ和HowTo banner
        // let faqShowState = true;
        //  sessionStorage.getItem('isShowFaqBanner');
        // setIsShowFaqBanner(!Boolean(faqShowState) && Boolean([3, 4].includes(structured_data.faq_generate_status)));
        // let howtoShowState = true;
        //  sessionStorage.getItem('isShowHowToBanner');
        // setIsShowHowToBanner(!Boolean(howtoShowState) && Boolean([3, 4].includes(structured_data.howto_generate_status)));
        // 计算已开启的开关数量
        let num = Object.values(all).filter(item => item.status === 1).length;
        setActiveNum(num)
    }, [structured_data])

    // 切换structured data编辑状态
    const handleToggleStructuredDataCol = () => {
        setStructuredDataCollStatus(!structuredDataCollStatus);
    }

    // 关闭
    const handleCloseFaqHowToBanner = (type) => {
        if (type === 'faq') {
            setIsShowFaqBanner(false);
        } else {
            setIsShowHowToBanner(false);
        }
        // try {
        //     sessionStorage.setItem(type === 'faq' ? 'isShowFaqBanner' : 'isShowHowToBanner', 'close')
        // } catch (e) { }
    }

    // StructList 名称 -> 新接口 action 字段
    const SWITCH_ACTION_MAP = {
        'has_product': 'product_switch',
        'has_breadcrumb': 'breadcrumb_list_switch',
        'has_organization': 'organization_switch',
        'has_article': 'article_switch',
    };

    const SCHEMA_SWITCH_ACTION_MAP = {
        'product_schema': 'product_switch',
        'breadcrumb_schema': 'breadcrumb_list_switch',
        'article_schema': 'article_switch',
    };

    // schema 类型 -> StructList 开关字段
    const SCHEMA_TYPE_TO_KEY = {
        'product_schema': 'has_product',
        'breadcrumb_schema': 'has_breadcrumb',
        'article_schema': 'has_article',
    };

    // 更新开关状态 (Product / Article / Organization / Breadcrumb)
    const handleUpdateSwitch = async (name) => {
        // 判断等级
        if (level === 1) {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
            setStructuredDataModalState(false);
            return;
        }

        // 获取 action
        const action = SWITCH_ACTION_MAP[name];
        if (!action) return;

        // 如果是组织并且开关关闭，直接跳转设置页
        if (0 && ['has_product', 'has_organization'].includes(name) && orgFirst && !Boolean(schemaSwitchArray[name].switch)) {
            setOrgFirst(false);
            // 跳转组织设置页
            const _search = new URLSearchParams(window.location.search);
            const id = _search.get('id');
            const from = _search.get('from');
            const _type = _search.get('type');
            const path = `/technicalSEO/structured-data/${name === 'has_product' ? 'product' : 'organization'}`;
            props.history.push(path, {
                id,
                from,
                type: _type,
            });
            return;
        } else {
            // 更新开关状态
            let newArray = cloneDeep(schemaSwitchArray);
            newArray[name].switch = !newArray[name].switch;
            setSchemaSwitchArray(newArray);
            setSwitchType(name);
            const params = {
                action,
                value: Number(newArray[name].switch),
            };
            const res = await reqUpdJLSwitch(params);
            //  回测开关状态
            if (res.code === 201 || res.code === '1000' || res.ack !== 1) {
                // 失败回滚
                newArray[name].switch = !newArray[name].switch;
                setSchemaSwitchArray(newArray);

                if (res.code === 201) {
                    setSwitchType('');
                    setEmbedModalStatus(true);
                    setEmbedUrl(res.data.url);

                    return;
                }
            }

            if (res.ack === 1) {
                props.toggleToast(t(res.msg), false);
                // 开关变更后刷新 SEO Checklist 与评分
                props.updateDataAnalysis();
            } else {
                if (res.code === '1000') {
                    props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
                } else {
                    props.toggleToast(t(res.msg), true);
                }
            }
            setSwitchType('');
        }
    }

    // 更新开关状态
    const updateSwitchStatus = async (params, schemaKey, isTip = true) => {
        let res = await reqUpSwitchJsonLdSwitchV2(params);

        //  回测开关状态
        if (res.code === 201 || res.code === '1000' || res.ack !== 1) {
            let newArray = cloneDeep(schemaSwitchArray);
            newArray[schemaKey].switch = params.value === 1 ? false : true;
            setSchemaSwitchArray(newArray);
        }

        if (res.code === 201) {
            // props.toggleToast(t(res.msg), true);
            setEmbedModalStatus(true);
            setEmbedUrl(res.data.url);
        } else if (res.code === '1000') {
            props.upgradeModal(1, 'JSONLD', 'content_audit_detail');
        } else if (res.ack === 1) {
            props.toggleToast(t(res.msg), false);
            // 开关变更后刷新 SEO Checklist 与评分
            props.updateDataAnalysis();
            if (!isTip) {
                setIsShowOriginalData(false);
                let newArray = cloneDeep(schemaSwitchArray);
                newArray[schemaKey].switch = params.value === 1 ? true : false;
                setSchemaSwitchArray(newArray);
            }
        } else {
            props.toggleToast(t(res.msg), true);
        }
        setSwitchType('');
    }

    // 打开组织设置
    const handleOpenStrSetting = (type) => {
        // if (level === 1) {
        //     props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
        //     setStructuredDataModalState(false);
        // } else {
        //     setIsShowOriginalData(true);
        // }
        const _search = new URLSearchParams(window.location.search);
        const id = _search.get('id');
        const from = _search.get('from');
        const _type = _search.get('type');
        const path = `/technicalSEO/structured-data/${type === 'has_product' ? 'product' : 'organization'}`;
        props.history.push(path, {
            id,
            from,
            type: _type,
        });
    }

    // 重置数据
    const resetData = () => {
        setLogoUrl(originData.logo_url || '');
        setOrganizationName(originData.organization_name || '');
        setSocialMediaData(originData.social_media_data || {});
    }

    // 输入框值改变
    const logoInputChangeValue = (name, value) => {
        if (name === "organization_name") {
            setOrganizationName(value);
        } else {
            setSocialMediaData({ ...social_media_data, [name]: value });
        }
    }

    // 保存和开启
    const handleSaveEnableData = () => {
        setSwitchType('has_organization');
        // 保存数据
        childRef.current.handleShopifySave();
        if (!Boolean(schemaSwitchArray.has_organization?.switch)) {
            // 更新开关状态
            let params = {
                action: 'organization_switch',
                value: 1,
            }
            updateSwitchStatus(params, 'has_organization', true);
        }
    }

    // 更新所有jsonld开关状态
    const updOpenJsonldAll = () => {
        getSwitchStatus();
        setOrgFirst(false);
    }

    // 更新图片上传状态
    const updImageUploadStatus = (state) => {
        setImageUploadStatus(state);
    }

    // 关闭设置弹窗
    const handleCloseSettingModal = () => {
        if (isShowOriginalData) {
            setIsShowOriginalData(false);
            setStructuredDataModalState(true);
            setSwitchType('');
        } else {
            setStructuredDataModalState(false);
        }
    }

    // 清除轮询数据定时器
    const clearTypeInterval = (type) => {
        switch (type) {
            case 'timerArr':
                timerArr.forEach(timer => {
                    clearInterval(timer);
                })
                timerArr = [];
                break;
            default:
                break;
        }
    }

    // 获取数据
    const handleGetGenerateInfo = async (type = []) => {
        let params = {
            sourceType: sourceType,
            id: objId,
        }
        const res = await reqGetStructuredDataGenerate(params);
        if (res.ack === 1) {
            const _t = res.data;
            const targetTypes = type.filter(item => ['faq', 'howto'].includes(item));
            const statusMap = {
                faq: _t?.faq?.status ?? 0,
                howto: _t?.howto?.status ?? 0,
            }

            let isEmpty = false;

            if (targetTypes.includes('faq')) {
                let faq_state = Boolean([3, 4].includes(statusMap.faq));
                isEmpty = faq_state;
                setIsShowFaqBanner(faq_state);
            }

            if (targetTypes.includes('howto')) {
                let howto_state = Boolean([3, 4].includes(statusMap.howto));
                isEmpty = howto_state;
                setIsShowHowToBanner(howto_state);
            }

            const shouldContinuePolling = targetTypes.some(item => statusMap[item] === 1 || statusMap[item] === 5);

            if (shouldContinuePolling) {
                if (timerArr.length === 0) {
                    let timer = setInterval(() => {
                        handleGetGenerateInfo(targetTypes);
                    }, 3000);
                    timerArr.push(timer);
                }
                return;
            }

            // 记录本次点击 Generate 并生成成功（status===2）的 schemaKey，用于输入框 AI 着色
            const successKeys = [];
            if (targetTypes.includes('faq') && statusMap.faq === 2) successKeys.push('has_faq');
            if (targetTypes.includes('howto') && statusMap.howto === 2) successKeys.push('has_how_to');
            if (successKeys.length) {
                setAiGeneratedKeys((prev) => Array.from(new Set([...prev, ...successKeys])));
                // 清掉这些 key 的会话草稿缓存，保证再次打开编辑弹窗读取的是后端最新生成内容（外层/弹窗内生成都生效）
                setSchemaContentStore((prev) => {
                    if (!successKeys.some((k) => k in prev)) return prev;
                    const next = { ...prev };
                    successKeys.forEach((k) => { delete next[k]; });
                    return next;
                });
            }

            // 提示
            props.toggleToast(isEmpty ? t("Generation failed.") : t("Generation successful."));
            props.updOpenJsonldStatus();
            props.updateDataAnalysis();
            setGenerateType([]);
            clearTypeInterval('timerArr');
            getSwitchStatus();
        }
    }

    const handleOpenSchemaEditor = (schemaKey) => {
        if (actionDisabled || !SCHEMA_KEY_EDITOR_TYPE[schemaKey]) return;
        setSchemaEditor((prev) => ({
            open: true,
            schemaKey,
            session: prev.session + 1,
        }));
    };

    const handleCloseSchemaEditor = () => {
        setSchemaEditor((prev) => ({ ...prev, open: false, schemaKey: '' }));
    };

    // 手工保存 FAQ / HowTo：POST /api/v2/on-page/{sourceType}/{id}/structured-data/content
    const handleSaveSchemaContent = async (payload) => {
        if (schemaSaving) return;
        const schemaKey = schemaEditor.schemaKey;
        const editorType = SCHEMA_KEY_EDITOR_TYPE[schemaKey]; // 'faq' | 'howto'
        const body = toSchemaApiBody(payload);

        setSchemaSaving(true);
        try {
            const res = await reqSaveStructuredDataContent({
                sourceType,
                id: objId,
                body,
            });

            // 仅提交单一类型，取对应结果字段（data.faq / data.howto）
            const typeResult = res?.data?.[editorType];
            if (res?.ack === 1 && typeResult?.ok !== false) {
                // 缓存本次保存内容，便于同会话内再次打开回显（真实回填等后端读取接口就绪后替换）
                setSchemaContentStore((prev) => ({ ...prev, [schemaKey]: payload }));
                setSchemaEditor((prev) => ({ ...prev, open: false, schemaKey: '' }));
                props.toggleToast(t(res.msg || "Changes saved."));
                // 刷新检测状态、开关与评分
                props.updOpenJsonldStatus();
                // 用实时检测刷新结构化数据（analysis 为缓存，拿不到最新内容/状态）
                props.updStructuredDataByDetect();
                getSwitchStatus();
            } else {
                // 失败（含部分失败 ok===false）：保留弹窗，提示错误，便于重试
                const errMsg = res?.errors?.[editorType]?.message || res?.msg || "Save failed.";
                props.toggleToast(t(errMsg), true);
            }
        } catch (e) {
            props.toggleToast(t("Save failed."), true);
        } finally {
            setSchemaSaving(false);
        }
    };

    // 生成信息
    const handleGenerateInfo = async (item = []) => {
        // 判断等级
        if (level === 1) {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
            return;
        }

        // 判断 是否开启超额 - 额度 0.1/page
        if (Number(creditsPoints) < 1) {
            props.verifyOverchargeState(0.1, level, ai_usage_status, aiUse);
            return;
        }

        if (actionDisabled || generateType.includes(item[0])) return;

        if (!generateType.includes(item[0])) {
            let c_type = cloneDeep(generateType);
            c_type.push(item[0]);
            setGenerateType(c_type);
        }
        let typeArr = item.map(i => i.includes('how') ? 'howto' : i.split('_')[1]);
        // 加入生成的对象
        if (item[0] === 'has_faq' && !generateArrRef.current.includes('faq')) {
            generateArrRef.current.push('faq');
            props.toggleToast(t("Generating FAQ schema") + "...");
        }
        if (item[0] === 'has_how_to' && !generateArrRef.current.includes('howto')) {
            generateArrRef.current.push('howto');
            props.toggleToast(t("Generating How-To schema") + "...");
        }
        let params = {
            sourceType,
            id: objId,
            open_json_ld: typeArr
        }
        const res = await reqBulkOpenJsonLd(params);
        if (res.code === 201) {
            props.updateDataAnalysis();
            setGenerateType([]);
            clearTypeInterval('timerArr');
            // 需要开扩展
            setEmbedModalStatus(true);
            setEmbedUrl(res.data.url);
        } else if (res.ack === 1) {
            // 判断其他状态
            // ok, shopify_failed, not_published, daily_limit_reached, failed
            const _t = res.data.results;
            if ((_t?.faq || '').includes('not_published') || (_t?.howto || '').includes('not_published')) {
                setPageUnpublishModalStatus(true);
                setGenerateType([]);
                props.updOpenJsonldStatus();
                getSwitchStatus();
            } else if ((_t?.faq || '').includes('daily_limit_reached') || (_t?.howto || '').includes('daily_limit_reached')) {
                props.toggleToast(t("Daily limit reached."));
                setGenerateType([]);
                props.updOpenJsonldStatus();
                getSwitchStatus();
            } else {
                // 轮询接口获取数据 
                handleGetGenerateInfo(generateArrRef.current);
            }
        } else {
            setErrorBanner(res.msg);
            setGenerateType([]);
        }
    }

    // 编辑弹窗里点击 Generate：调起 AI 生成，生成完成后内容刷新会让弹窗以后端最新内容重挂、覆盖草稿
    const handleGenerateSchemaFromModal = (schemaKey) => {
        // 清掉会话缓存，保证生成后重挂读取的是后端最新内容而非旧的已保存草稿
        setSchemaContentStore((prev) => {
            if (!(schemaKey in prev)) return prev;
            const next = { ...prev };
            delete next[schemaKey];
            return next;
        });
        handleGenerateInfo([schemaKey]);
    };

    // 发布页面
    const handlePublishPage = async () => {
        setPublishPageLoading(true);
        props.handlePublishData();
    }

    // 启用单个jsonld
    const handleEnableItem = async (item) => {
        if (['has_review'].includes(item)) {
            handleOpenStrSetting('has_product');
        } else if (['has_review', 'has_shipping', 'has_return'].includes(item)) {
            handleOpenStrSetting('has_organization');
        } else {
            setStructuredDataModalState(true)
        }
    }

    // FAQ / How-To 模块是否已开启（店铺级开关，来自 reqGetJLPageData 的 config）
    const isFaqHowtoEnabled = (item) => {
        const moduleName = item === 'has_how_to' ? 'howto' : 'faq';
        return Boolean(configData?.[moduleName]?.enabled);
    };

    // 打开 FAQ / How-To 设置弹窗
    const handleOpenFaqHowtoSettings = (item) => {
        if (level === 1) {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
            return;
        }
        const moduleType = ITEM_TO_MODULE_TYPE[item];
        if (!moduleType) return;
        // 已有保存的 page_types 则回填（过滤掉非该模块支持的值），否则使用默认勾选
        const saved = faqHowtoPageTypes[moduleType];
        const validValues = getPageOptions(moduleType).map((o) => o.value);
        const filtered = Array.isArray(saved) ? saved.filter((v) => validValues.includes(v)) : [];
        setSettingsSelectedPages(filtered.length > 0 ? filtered : getDefaultSelectedPages(moduleType));
        setSettingsModalType(moduleType);
    };

    // 关闭 FAQ / How-To 设置弹窗
    const handleCloseFaqHowtoSettings = () => {
        if (settingsSaveLoading) return;
        setSettingsModalType('');
    };

    // 保存并开启 FAQ / How-To 模块（Save & Enable）
    const handleSaveFaqHowtoSettings = async () => {
        if (level === 1) {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
            setSettingsModalType('');
            return;
        }
        if (!settingsSelectedPages.length) {
            props.toggleToast(t('Please select at least one page type'), true);
            return;
        }
        const moduleType = settingsModalType;
        const action = FAQ_HOWTO_ACTION_MAP[moduleType];
        if (!action) return;
        setSettingsSaveLoading(true);
        const res = await reqSaveJLData({ action, enabled: 1, page_types: settingsSelectedPages });
        setSettingsSaveLoading(false);
        if (res.ack === 1) {
            props.toggleToast(t(res.msg), false);
            setFaqHowtoPageTypes((prev) => ({ ...prev, [moduleType]: settingsSelectedPages }));
            setSettingsModalType('');
            // 刷新开关 / 统计，并同步 SEO 评分
            // props.updateDataAnalysis && props.updateDataAnalysis();
            // 用实时检测刷新结构化数据（analysis 为缓存，拿不到最新内容/状态）
            props.updStructuredDataByDetect();
            getSwitchStatus();
        } else if (res.code === '1000') {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
        } else {
            props.toggleToast(t(res.msg), true);
        }
    };

    // 打开开关（FIX 直接开启对应开关，不跳转设置页）
    const handleOpenSwitch = async (type) => {
        // 判断等级
        if (level === 1) {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
            setStructuredDataModalState(false);
            props.fixSchemaDone && props.fixSchemaDone(false);
            return;
        }

        // 获取 action 及对应开关字段
        const action = SCHEMA_SWITCH_ACTION_MAP[type];
        const schemaKey = SCHEMA_TYPE_TO_KEY[type];
        if (!action || !schemaKey) {
            props.fixSchemaDone && props.fixSchemaDone(false);
            return;
        }

        // 已开启则无需重复请求
        if (Boolean(schemaSwitchArray[schemaKey]?.switch)) {
            props.fixSchemaDone && props.fixSchemaDone(false);
            return;
        }

        // 乐观更新开关状态
        let newArray = cloneDeep(schemaSwitchArray);
        newArray[schemaKey].switch = true;
        setSchemaSwitchArray(newArray);
        setSwitchType(schemaKey);

        const params = {
            action,
            value: 1,
        };
        const res = await reqUpdJLSwitch(params);

        // 失败回滚开关状态
        if (res.code === 201 || res.code === '1000' || res.ack !== 1) {
            newArray[schemaKey].switch = false;
            setSchemaSwitchArray(newArray);
            props.fixSchemaDone && props.fixSchemaDone(false);

            if (res.code === 201) {
                setSwitchType('');
                setEmbedModalStatus(true);
                setEmbedUrl(res.data.url);
                return;
            }
        }

        if (res.ack === 1) {
            props.toggleToast(t(res.msg), false);
            props.updateDataAnalysis();
            props.fixSchemaDone && props.fixSchemaDone(true);
        } else if (res.code === '1000') {
            props.upgradeModal(1, 'StructuredData', 'content_audit_detail');
        } else {
            props.toggleToast(t(res.msg), true);
        }
        setSwitchType('');
    }

    // 设置jsonldTestUrl
    useEffect(() => {
        setJsonldTestUrl(jsonLdTestUrl);
    }, [jsonLdTestUrl]);

    useEffect(() => {
        setIsPublishPage(isPublishState);
    }, [isPublishState]);

    useEffect(() => {
        if (updOpenJSONLD) {
            // 需要判断哪些不是active， 排除author；且只发起当前页面类型下的字段
            let updArr = Object.keys(schemaAll).filter(item => !schemaAll[item].status && [
                "has_product", "has_article", "has_faq", "has_how_to", "has_breadcrumb", "has_organization"
            ].includes(item) && currentTypeFields.includes(item));
            if (updArr.length > 0) {
                handleGenerateInfo(updArr);
            } else {
                props.updOpenJsonldStatus();
            }
        }
    }, [updOpenJSONLD]);

    useEffect(() => {
        setPublishPageLoading(publishLoading);
        if (!publishLoading) {
            setPageUnpublishModalStatus(false);
        }
    }, [publishLoading]);

    useEffect(() => {
        if (structureModalType === 'faq_schema') {
            setStructuredDataCollStatus(true);
            handleGenerateInfo(['has_faq']);
        } else if (['article_schema', 'product_schema', 'breadcrumb_schema'].includes(structureModalType)) {
            handleOpenSwitch(structureModalType);
        } else {
            return;
        }
    }, [structureModalType]);

    useEffect(() => {
        setActionDisabled(disabled);
    }, [disabled]);

    useEffect(() => {
        let _page = store.getState().page;
        getSwitchStatus(_page.pageInit['StructuredData']?.ack ? _page.pageInit['StructuredData'] : null);

        return () => {
            clearTypeInterval('timerArr');
        }

    }, []);


    // 开启状态
    const schemaStatus = (status = 0) => {
        return status === 1 ? <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6242 7.22465C10.8585 6.99034 10.8585 6.61044 10.6242 6.37613C10.3899 6.14181 10.01 6.14181 9.77564 6.37613L7.3999 8.75186L6.42417 7.77613C6.18985 7.54181 5.80995 7.54181 5.57564 7.77613C5.34132 8.01044 5.34132 8.39034 5.57564 8.62465L6.97564 10.0247C7.20995 10.259 7.58985 10.259 7.82417 10.0247L10.6242 7.22465Z" fill="#27AE60" />
            <path fillRule="evenodd" clipRule="evenodd" d="M13.5999 8.00039C13.5999 11.0932 11.0927 13.6004 7.9999 13.6004C4.90711 13.6004 2.3999 11.0932 2.3999 8.00039C2.3999 4.9076 4.90711 2.40039 7.9999 2.40039C11.0927 2.40039 13.5999 4.9076 13.5999 8.00039ZM12.3999 8.00039C12.3999 10.4304 10.43 12.4004 7.9999 12.4004C5.56985 12.4004 3.5999 10.4304 3.5999 8.00039C3.5999 5.57034 5.56985 3.60039 7.9999 3.60039C10.43 3.60039 12.3999 5.57034 12.3999 8.00039Z" fill="#27AE60" />
        </svg> : <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="5.25" stroke="#CCCCCC" strokeWidth="1.5" />
        </svg>;
    }

    // 页面未发布弹窗
    const pageUnpublishModal = <Modal
        size='small'
        title={t("Publish this page to enable structured data")}
        open={pageUnpublishModalStatus}
        onClose={() => setPageUnpublishModalStatus(false)}
        primaryAction={{
            content: t("Publish page"),
            onAction: handlePublishPage,
            loading: publishPageLoading,
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => setPageUnpublishModalStatus(false),
                disabled: publishPageLoading,
            }
        ]}
    >
        <Modal.Section>
            <p>{t("Structured data only works on published pages. Publish this page first so search engines can crawl and display rich results.")}</p>
        </Modal.Section>
    </Modal>

    // 扩展提示弹窗
    const embedModal = <Modal
        size='small'
        title={t("Enable App Embed to continue")}
        open={embedModalStatus}
        onClose={() => setEmbedModalStatus(false)}
        primaryAction={{
            content: t("Enable in theme"),
            onAction: () => {
                window.open(embedUrl, '_blank');
            }
        }}
        secondaryActions={[
            {
                content: t("Cancel"),
                onAction: () => {
                    setEmbedModalStatus(false);
                }
            }
        ]}
    >
        <Modal.Section>
            <p>{t("To add structured data, the app embed must be enabled in your theme.")}</p>
        </Modal.Section>
    </Modal>

    // 设置结构性数据弹窗
    const StructuredDataModal = <Modal
        open={structuredDataModalState && !embedModalStatus}
        title={t("Structure Data Settings")}
        onClose={handleCloseSettingModal}
        secondaryActions={isShowOriginalData ? [
            {
                content: t("Back"),
                onAction: handleCloseSettingModal,
                disabled: Boolean(switchType || imageUploadStatus)
            },
        ] : null}
        primaryAction={isShowOriginalData ? {
            content: t("Save & Enable"),
            onAction: handleSaveEnableData,
            loading: switchType === 'has_organization',
            disabled: imageUploadStatus
        } : null}
    >
        <Modal.Section>
            {
                !isShowOriginalData ? <div className='structured_data_container'>
                    <BlockStack gap={400}>
                        <Text variant="bodySm" as="p" tone="subdued">{t("Enable structured data to improve search and AI visibility. This setting applies to all pages.")}</Text>
                        <div className='structured_data_setting_main'>
                            {
                                Object.keys(schemaAll).map((item, index) => {
                                    return ["has_product", "has_breadcrumb", "has_organization", "has_article"].includes(item) ? <div key={`modal-${item}-${index}`} className='flex_layout structured_data_setting_item'>
                                        <span className='structured_data_setting_icon'>{schemaAll[item].icon}</span>
                                        <div className='structured_data_setting_info'>
                                            <Text variant="bodyLg" as="p">{t(schemaAll[item].title)}</Text>
                                            <Text variant="bodySm" as="p" tone='subdued'>{t(schemaAll[item].helpText)}</Text>
                                        </div>
                                        {
                                            switchType === item && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />
                                        }
                                        {
                                            ['has_product', 'has_organization'].includes(item) && <Button disabled={Boolean(switchType)} icon={SettingsIcon} onClick={() => handleOpenStrSetting(item)}></Button>
                                        }
                                        <Switch disabled={Boolean(switchType)} onChange={() => handleUpdateSwitch(item)} checked={Boolean(schemaSwitchArray[item].switch)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                                    </div> : null;
                                })
                            }
                        </div>
                    </BlockStack>
                </div> : <div className='structured_data_original_data_container'>
                    <BlockStack gap={400}>
                        <div className='flex_layout'>
                            <Button icon={ChevronLeftIcon} variant='tertiary' onClick={handleCloseSettingModal}></Button>
                            <Text variant="bodyMd" as="p">{t("Organization Info Settings")}</Text>
                        </div>
                        <div className='structured_data_original_data'>
                            <LogoForms
                                ref={childRef}
                                isOtherModule={true}
                                loading={loading}
                                logo_url={logo_url}
                                organization_name={organization_name}
                                social_media_data={social_media_data}
                                originData={originData}
                                resetData={resetData}
                                upgradeModal={props.upgradeModal}
                                updOpenJsonldAll={updOpenJsonldAll}
                                updImageUploadStatus={updImageUploadStatus}
                                logoInputChangeValue={(name, value) => logoInputChangeValue(name, value)}
                            />
                        </div>
                    </BlockStack>
                </div>
            }
        </Modal.Section>
    </Modal>

    // 当前页面类型默认展示的字段（检测值为 1 的字段无论类型都会展示）
    const currentTypeFields = STRUCTURED_DATA_TYPE_FIELDS[sourceType || pagetype] || STRUCTURED_DATA_TYPE_FIELDS.product;

    // FAQ / How-To 设置弹窗派生数据
    const settingsCfg = buildSettingsCfg({
        statistics,
        config: configData,
        moduleType: settingsModalType,
        selectedPages: settingsSelectedPages,
    });
    const faqHowtoSettingsModal = (
        <SchemaSettingsModal
            open={Boolean(settingsModalType && !techVideoState)}
            type={settingsModalType}
            config={settingsCfg}
            pageOptions={settingsModalType ? getPageOptions(settingsModalType) : []}
            selectedPages={settingsSelectedPages}
            ulevel={level}
            overageEnabled={Boolean(statistics?.overage?.enabled)}
            saveLoading={settingsSaveLoading}
            primaryActionText={t('Save & Enable')}
            onSelectedPagesChange={(selected) => setSettingsSelectedPages(selected)}
            onClose={handleCloseFaqHowtoSettings}
            onSave={handleSaveFaqHowtoSettings}
            onUpgrade={() => props.upgradeModal(1, 'StructuredData', 'content_audit_detail')}
            onViewHow={() => setTechVideoState(true)}
        />
    );

    // "View how" 教学视频弹窗（与 SnippetsJSONLD 一致）
    const howUseVideoModal = (
        <Modal
            title={t("How to generate FAQ & How to schema with SEOWILL")}
            size="large"
            open={techVideoState}
            onClose={() => setTechVideoState(false)}
        >
            <div className={'youtube-video-box'}>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/j2igY8s6qyc?si=_IwHLZ_H6OHMtx9I" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
        </Modal>
    );

    // 列表展示顺序：FAQ、HowTo 置顶（FAQ 第一、HowTo 第二），其余保持原有顺序
    const SCHEMA_DISPLAY_ORDER = ['has_faq', 'has_how_to'];
    const sortSchemaKeys = (keys) => [...keys].sort((a, b) => {
        const ia = SCHEMA_DISPLAY_ORDER.indexOf(a);
        const ib = SCHEMA_DISPLAY_ORDER.indexOf(b);
        if (ia === -1 && ib === -1) return 0; // 两者都不在置顶列表，保持原序（sort 稳定）
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
    });

    // FAQ / HowTo 内容是否为空（会话缓存优先，其次后端 structured_data 内容）
    const isSchemaContentEmpty = (schemaKey) => {
        const cached = schemaContentStore[schemaKey];
        if (cached) {
            return (cached.items || cached.steps || []).length === 0;
        }
        return parseSchemaContentString(structured_data?.[SCHEMA_KEY_CONTENT_FIELD[schemaKey]]).length === 0;
    };

    // FAQ / HowTo 内容是否由 AI 生成：仅在本会话内点击 Generate 且接口返回生成成功后着色（非后端持久化状态）
    const isSchemaAiGenerated = (schemaKey) => aiGeneratedKeys.includes(schemaKey);

    // FAQ / HowTo 是否为外部（已检测但非本应用添加）：faq_generated_by_app / howto_generated_by_app，1 为内部，其他为外部
    const isFaqHowtoExternal = (schemaKey) => {
        const isFaq = schemaKey.includes('faq');
        const isHowTo = schemaKey.includes('how_to');
        if (!isFaq && !isHowTo) return false;
        const detected = schemaAll[schemaKey]?.status === 1;
        const generatedByApp = isFaq ? structured_data?.faq_generated_by_app : structured_data?.howto_generated_by_app;
        return detected && Number(generatedByApp) !== 1;
    };

    // FAQ / HowTo 标题后的标签：外部检测（非本应用添加）或内容数量
    const renderSchemaTag = (schemaKey) => {
        const isFaq = schemaKey.includes('faq');
        const isHowTo = schemaKey.includes('how_to');
        if (!isFaq && !isHowTo) return null;

        if (isFaqHowtoExternal(schemaKey)) {
            return <Badge tone='success'>{t("Detected externally")}</Badge>;
        }

        // 模块开关关闭时不展示标签
        if (configData && !isFaqHowtoEnabled(schemaKey)) return null;

        // 内容数量：FAQ 为条目数，HowTo 为全部步骤数
        const count = isFaq
            ? parseSchemaContentString(structured_data?.faq_content).length
            : parseSchemaContentString(structured_data?.how_to_content).reduce((sum, h) => sum + (h?.steps?.length || 0), 0);

        if (count > 0) {
            return <Badge tone='success'>{isFaq ? t("{{v1}} FAQs added", count) : t("{{v1}} steps added", count)}</Badge>;
        }

        return null;
    };

    // 结构化数据模块
    const structuredBlock = <Card>
        {
            errorBanner && <>
                <Banner
                    title={t(errorBanner)}
                    tone='critical'
                    onDismiss={() => {
                        setErrorBanner('');
                    }}
                    action={{
                        content: t("Contact us"),
                        onAction: props.handleContactService
                    }}
                >
                </Banner>
                <br />
            </>
        }
        <div className='flex_layout structured_data_header'>
            <span style={{ marginTop: '-20px' }}><Icon source={CodeIcon} tone='base' /></span>
            <div className='structured_data_header_content'>
                <div className='flex_layout header_title' style={{ marginBottom: '4px' }}>
                    <Text variant="headingMd" as="h2">{t("Structured Data")}</Text>
                    <Badge tone='success'>{t("{{v1}} detected", activeNum)}</Badge>
                </div>
                <Text variant="bodySm" as="p" tone='subdued'>{t("Boost search and AI visibility with automated schema.")}</Text>
            </div>
            <Button icon={!structuredDataCollStatus ? ChevronDownIcon : ChevronUpIcon} onClick={handleToggleStructuredDataCol} variant='tertiary'></Button>
        </div>
        <Collapsible
            id="audit_structured_data_collapsible"
            open={structuredDataCollStatus}
            transition={{ duration: '300ms', timingFunction: 'ease-in-out' }}
            expandOnPrint
        >
            <div className='structured_data_content'>
                {
                    syncStructLoading && <div className='structured_data_loading'>
                        <img width={20} src={"/imgs/Image/loading.gif"} alt='' />
                    </div>
                }
                <BlockStack gap={300}>
                    <div className='schema_item_list'>
                        {
                            sortSchemaKeys(Object.keys(schemaAll)
                                .filter(item => schemaAll[item].status === 1 || currentTypeFields.includes(item)))
                                .map((item, index) => {
                                    // 检测为已开启(status===1)但不属于当前页面类型的字段：非本应用添加，不可在此配置
                                    // FAQ / HowTo 额外依据 generated_by_app 判断外部（与 Detected externally 徽章一致）
                                    const isExternal = (schemaAll[item].status === 1 && !currentTypeFields.includes(item)) || isFaqHowtoExternal(item);
                                    return (item === "has_author" && !Boolean(schemaAll?.has_article?.status)) ? null : <div key={`col-${item}-${index}`} className={`flex_layout schema_item ${['has_faq', 'has_how_to'].includes(item) ? 'special_item' : ''}`}>
                                        <span>{schemaStatus(schemaAll[item].status)}</span>
                                        <span>{schemaAll[item].icon}</span>
                                        <div className='schema_item_info'>
                                            <InlineStack gap={200} blockAlign="center">
                                                <Text variant="bodyMd" as="p">{t(schemaAll[item].title)}</Text>
                                                {renderSchemaTag(item)}
                                            </InlineStack>
                                            <div className='schema_item_desc'>
                                                <Text variant="bodySm" as="p" tone='subdued'>{t(schemaAll[item].desc)}</Text>
                                            </div>
                                        </div>
                                        {
                                            item !== "has_author" && (
                                                (item.includes('faq') || item.includes('how_to')) ? (
                                                    isExternal ? <Tooltip content={t("This schema was added externally. To make changes, please edit it in the original app or theme.")}>
                                                        <div className='schema_item_actions disabled_btn_struct'>
                                                            <Button disabled>{t("Edit")}</Button>
                                                        </div>
                                                    </Tooltip> : (configData && !isFaqHowtoEnabled(item)) ? (
                                                        // 模块未开启：显示 Enable 按钮，点击打开 Save & Enable 设置弹窗
                                                        <div className='schema_item_actions'>
                                                            <Button disabled={actionDisabled} size='micro' onClick={() => handleOpenFaqHowtoSettings(item)}>
                                                                <div className='flex_layout'>
                                                                    <span>{t("Enable")}</span>
                                                                    <span><Icon source={ArrowRightIcon} tone='base' /></span>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                    ) : <div className={`schema_item_actions ${generateType.includes(item) ? 'generate_show_btn' : ''} ${actionDisabled ? 'disabled_btn_struct' : ''}`}>
                                                        <Button disabled={actionDisabled} onClick={() => handleOpenSchemaEditor(item)}>{t("Edit")}</Button>
                                                        {
                                                            // Generate 仅在内容为空时显示；Regenerate 已去掉
                                                            isSchemaContentEmpty(item) && <div className='ai_powered_btn' onClick={() => handleGenerateInfo([item])}>
                                                                {
                                                                    generateType.includes(item) ? <Spinner size="small" /> : <Icon source={MagicIcon} tone='subdued' />
                                                                }
                                                                <span>{t("Generate")}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                ) : (
                                                    isExternal ? <Tooltip content={t("This schema was added externally. To make changes, please edit it in the original app or theme.")}>
                                                        <div className='schema_item_actions'>
                                                            <Button disabled size='micro'>
                                                                <div className='flex_layout'>
                                                                    <span>{t("Enable")}</span>
                                                                    <span><Icon source={ArrowRightIcon} tone='base' /></span>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                    </Tooltip> : <div className='schema_item_actions'>
                                                        <Button disabled={actionDisabled} size='micro' onClick={() => handleEnableItem(item)}>
                                                            <div className='flex_layout'>
                                                                <span>{t("Enable")}</span>
                                                                <span><Icon source={ArrowRightIcon} tone='base' /></span>
                                                            </div>
                                                        </Button>
                                                    </div>
                                                )
                                            )
                                        }
                                    </div>;
                                })
                        }
                    </div>
                    {
                        // 编辑弹窗打开时，提示展示在弹窗内，这里外层不再重复展示
                        isShowFaqBanner && !schemaEditor.open && <Banner
                            tone='info'
                            title={
                                t("Cannot generate FAQ. Please add FAQ sections to your page content first.")
                            }
                            onDismiss={() => handleCloseFaqHowToBanner('faq')}
                        ></Banner>
                    }
                    {
                        isShowHowToBanner && !schemaEditor.open && <Banner
                            tone='info'
                            title={
                                t("Cannot generate HowTo schema. Please add HowTo sections to your page content first.")
                            }
                            onDismiss={() => handleCloseFaqHowToBanner('howto')}
                        ></Banner>
                    }
                    {
                        isPublishPage && <BlockStack inlineAlign="end">
                            <Tooltip content={t("Open Google's Rich Result Test tool to check which structured data has been detected on your page.")}>
                                <Button variant='plain' onClick={() => {
                                    window.open(jsonldTestUrl, '_blank');
                                }}>
                                    <InlineStack gap={100}>
                                        <span>{t("Test with Google")}</span>
                                        <span><Icon source={ArrowRightIcon} /></span>
                                    </InlineStack>
                                </Button>
                            </Tooltip>
                        </BlockStack>
                    }
                </BlockStack>
            </div>
        </Collapsible>
    </Card>

    return <div id='structured_data_module'>
        {structuredBlock}
        {StructuredDataModal}
        {faqHowtoSettingsModal}
        {howUseVideoModal}
        {embedModal}
        {pageUnpublishModal}
        {schemaEditor.open && SCHEMA_KEY_EDITOR_TYPE[schemaEditor.schemaKey] && !pageUnpublishModalStatus ? (
            <SchemaContentEditor
                // 后端内容变化（如生成完成）时重挂，用最新内容覆盖草稿
                key={`${schemaEditor.schemaKey}-${schemaEditor.session}-${structured_data?.[SCHEMA_KEY_CONTENT_FIELD[schemaEditor.schemaKey]] || ''}`}
                editorType={SCHEMA_KEY_EDITOR_TYPE[schemaEditor.schemaKey]}
                content={
                    // 会话内已保存的内容优先；否则用后端 structured_data 里的内容回填
                    schemaContentStore[schemaEditor.schemaKey]
                    ?? fromSchemaApiContent(
                        SCHEMA_KEY_EDITOR_TYPE[schemaEditor.schemaKey],
                        structured_data?.[SCHEMA_KEY_CONTENT_FIELD[schemaEditor.schemaKey]]
                    )
                }
                saveLoading={schemaSaving}
                generating={generateType.includes(schemaEditor.schemaKey)}
                aiGenerated={isSchemaAiGenerated(schemaEditor.schemaKey)}
                showEmptyBanner={SCHEMA_KEY_EDITOR_TYPE[schemaEditor.schemaKey] === 'faq' ? isShowFaqBanner : isShowHowToBanner}
                onClose={handleCloseSchemaEditor}
                onSave={handleSaveSchemaContent}
                onGenerate={() => handleGenerateSchemaFromModal(schemaEditor.schemaKey)}
                onDismissEmptyBanner={() => handleCloseFaqHowToBanner(SCHEMA_KEY_EDITOR_TYPE[schemaEditor.schemaKey] === 'faq' ? 'faq' : 'howto')}
            />
        ) : null}
    </div>;
}

export default withRouter(StructuredData);